var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.48081 35.8101L0.556152 0.0668945L35.4842 0.138722L32.3916 35.8101L18.152 39.9333L3.48081 35.8101Z",
    fill: "#E9CA32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1519 36.481V3.4707L32.5354 3.51859L29.9705 33.0527L18.1519 36.481Z",
    fill: "#FFDE25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6118 7.39062H12.8091V29.3615L9.85153 28.7981V25.8405L6.33057 25.2771V31.8966L16.6118 34.5725V7.39062ZM19.4643 7.39062H29.9915L29.2873 11.6017H23.483V18.5121H29.2873L28.5831 32.4599L19.4643 34.5725V30.2065L25.6255 28.0939L25.9812 22.3195L19.4643 23.2631V7.39062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.928,
    height: 40,
    fill: "white",
    transform: "translate(0.556152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.b0e40b11fcf65f1b539a963e1541d555.svg";
export { ForwardRef as ReactComponent };